import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  productTypeFromModel,
  validateProductTypeCondition,
  type ProductTypeState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductTypeState>>,
): ConditionType<ProductTypeState, Condition.ProductType> => ({
  name: "Product type",
  description(state) {
    return `Product type: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductTypeState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.ProductType) {
    return productTypeFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_TYPE, productTypes: state };
  },
  valid(state) {
    return validateProductTypeCondition(state).valid;
  },
});

export { type ProductTypeState } from "@redotech/redo-model/return-flow/condition-validate";
